// Raw fetch to requests-submit (franklycatering #497) — not
// supabase.functions.invoke, so we get a real AbortController deadline and
// the HTTP status for retryability classification.
import type { RequestPayload } from "./queue";

export const REQUESTS_FUNCTION_URL =
  "https://seakhhfbaropdsjjxvll.supabase.co/functions/v1/requests-submit";
// Mirrors the hardcoded project URL in src/integrations/supabase/client.ts,
// which is generated ("Do not edit it directly") and exports no URL constant.

export class RequestSubmitError extends Error {
  readonly status: number;
  constructor(message: string, status: number) {
    super(message);
    this.name = "RequestSubmitError";
    this.status = status;
  }
}

const DEADLINE_MS_NO_SHOT = 8_000;
const DEADLINE_MS_WITH_SHOT = 12_000;

export async function submitRequest(payload: RequestPayload, accessToken: string | null): Promise<void> {
  const deadline = payload.screenshot_b64 ? DEADLINE_MS_WITH_SHOT : DEADLINE_MS_NO_SHOT;
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), deadline);

  try {
    const res = await fetch(REQUESTS_FUNCTION_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
      },
      body: JSON.stringify(payload),
      signal: controller.signal,
    });

    if (!res.ok) {
      let message = `request failed with status ${res.status}`;
      try {
        const body = (await res.json()) as { error?: string };
        if (body?.error) message = body.error;
      } catch {
        // ignore — keep the generic message
      }
      throw new RequestSubmitError(message, res.status);
    }
  } finally {
    clearTimeout(timer);
  }
}
